import React from "react";

function Footer(_props) {
  return (
    <div className="footer-logo py-2 px-2">
      {/* <p className="text-center">Powered by</p>
      <img src="/assets/img/logo-small.png" alt="logo" /> */}
    </div>
  );
}

export default Footer;
